var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useQueryClient } from '@tanstack/react-query';
import { useCallback, useEffect, useRef } from 'react';
import { useToastService } from '@lucidlink/uicore';
import { useCopyToClipboardWithToast } from '#hooks';
import { LucidDevToolsKeyFactory } from '../query-hooks';
import { createWebFsLogsFilename, downloadWithFilePicker, logsToString, MimeType, } from '../services';
export const useLogging = (observableLogger) => {
    _react_refresh_temp_1();
    const queryClient = useQueryClient();
    const { addToast } = useToastService();
    const { copyToClipboard } = useCopyToClipboardWithToast();
    const logs = useRef([]);
    const handleLogs = useCallback((event) => {
        logs.current.push({
            level: event.level.label,
            timestamp: event.ts,
            // eslint-disable-next-line @typescript-eslint/no-base-to-string -- objects already JSON-stringified in the map below; remaining values are primitives. Preserves original coercion behavior
            message: event.messages
                .map((message) => {
                return typeof message === 'object'
                    ? JSON.stringify(message)
                    : message;
            })
                .join(', '),
        });
    }, []);
    useEffect(() => {
        observableLogger?.subscribe(handleLogs);
        return () => observableLogger?.unsubscribe(handleLogs);
    }, [observableLogger, handleLogs]);
    const clearLogs = useCallback(() => {
        logs.current = [];
        void queryClient.invalidateQueries({
            queryKey: LucidDevToolsKeyFactory.shownLogs(),
        });
    }, [queryClient]);
    const downloadLogs = useCallback(() => {
        downloadWithFilePicker(createWebFsLogsFilename(), MimeType.Text, logsToString(logs.current));
    }, []);
    const copyLogsToClipboard = useCallback(() => {
        void copyToClipboard(logsToString(logs.current), {
            onSuccess: () => {
                addToast({
                    content: {
                        message: 'WebFS logs have been copied to your clipboard!',
                    },
                    kind: 'positive',
                    'data-testid': 'success-copy-logs',
                });
            },
        });
    }, [copyToClipboard, addToast]);
    return { logs: logs.current, clearLogs, downloadLogs, copyLogsToClipboard };
};
_react_refresh_temp_1(useLogging, "evvpb5wf3yHdx69VuNBmjX8k2K8=", false, () => [useQueryClient, useToastService, useCopyToClipboardWithToast]);
